export default class Publisher {
    constructor(initialState) {
        this.listeners = [];
        this.currentState = initialState;
    }

    getState() {
        return this.currentState;
    }

    setState(state) {
        this.currentState = {
            ...this.currentState,
            ...state,
        };

        this.listeners.forEach((listenerCallback) => {
            if (listenerCallback.isUnsubscribed) {
                return;
            }
            listenerCallback(this.currentState);
        });
    }

    subscribe(listenerCallback) {
        this.listeners.push(listenerCallback);

        return () => {
            // eslint-disable-next-line no-param-reassign
            listenerCallback.isUnsubscribed = true;
            this.listeners = this.listeners.filter(callback => callback !== listenerCallback);
        };
    }
}



// WEBPACK FOOTER //
// ./src/frontend/common/Publisher.js